module.exports = __webpack_public_path__ + "static/BeVapeFree.org-Terms-of-Use-2020-c16f319e5d27ffcf155367bae3064e70.pdf";